import { Controller } from "@hotwired/stimulus";

// Swaps a deliverable card's action row for an inline note form.
//
// Requesting changes or rejecting used to navigate to a dedicated full-page
// form, which meant the reviewer lost the content they were looking at, lost
// their scroll position, and came back to the top of the list. Now the form
// opens in place on the card and the response replaces just that card.
export default class extends Controller {
  static targets = ["menu", "panel"];

  open(event) {
    event.preventDefault();
    const name = event.params.panel;

    this.menuTarget.hidden = true;
    this.panelTargets.forEach((panel) => {
      const match = panel.dataset.panelName === name;
      panel.hidden = !match;
      if (match) {
        const field = panel.querySelector("textarea");
        if (field) {
          field.focus();
        }
      }
    });
  }

  close(event) {
    if (event) event.preventDefault();

    this.panelTargets.forEach((panel) => {
      panel.hidden = true;
      const field = panel.querySelector("textarea");
      if (field) field.value = "";
    });
    this.menuTarget.hidden = false;
  }

  // Cmd/Ctrl + Enter submits, matching the comment editor elsewhere in the app.
  submitOnMeta(event) {
    if (event.key !== "Enter" || !(event.metaKey || event.ctrlKey)) return;

    const form = event.target.closest("form");
    if (form) form.requestSubmit();
  }
}
